import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Nosotros from "./components/Nosotros";
import CTA from "./components/CTA";
import Servicios from "./components/Servicios";
import SmartConnect from "./components/SmartConnect";
import Statement from "./components/Statement";
import Contacto from "./components/Contacto";
import Footer from "./components/Footer";

const Landing = () => {
  return (
    <div className="App" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Nosotros />
        <CTA />
        <Servicios />
        <SmartConnect />
        <Statement />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
